import type { CSSProperties } from 'react';

const SHADOW_WIDTH = 12;

const edgeShadowBase: CSSProperties = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  width: SHADOW_WIDTH,
  pointerEvents: 'none',
  zIndex: 10,
};

export const pinnedEdgeShadowLeftStyle: CSSProperties = {
  ...edgeShadowBase,
  right: -SHADOW_WIDTH,
  background: 'linear-gradient(to right, rgba(0,0,0,0.1), transparent)',
};

export const pinnedEdgeShadowRightStyle: CSSProperties = {
  ...edgeShadowBase,
  left: -SHADOW_WIDTH,
  background: 'linear-gradient(to left, rgba(0,0,0,0.1), transparent)',
};

export const pinnedColumnBg =
  'group-odd:bg-white group-even:bg-surface-subtle group-hover:bg-surface-soft';

export const borderColumnBg = `
  before:absolute
  before:inset-y-0
  before:content-['']
  before:-z-10
  group-odd:before:bg-white
  group-even:before:bg-surface-subtle
  group-hover:before:bg-surface-soft
`;

export const borderLeftPinnedColumnBg = `
  overflow-visible
  before:left-0
  before:right-0

  ${borderColumnBg}
`;

export const borderRightPinnedColumnBg = `
  overflow-visible
  before:left-0
  before:right-0

  ${borderColumnBg}
`;
